import { geoConicEquidistant } from 'd3';
import FieldSequenceControl from './FieldSequenceControl';

export default {
  mixins: [
    FieldSequenceControl,
  ],
  methods: {
    copyField(campoBase, listaCampos) {
      console.log(campoBase);
      console.log(listaCampos);
      let campoNovo = {
        Id: this.generateUUID(),
        active: campoBase.active,
        sequenceNumber: this.getNextSequenceNumber(listaCampos),
        required: campoBase.required,
        type: campoBase.type,
        displayName: campoBase.displayName,
        tip: campoBase.tip,
        uniqueKey: campoBase.uniqueKey,
        visibility: campoBase.visibility,
        values: [],
        allowAttachment: false,
        isMandatoryAttachment: false,
        dateCreate: null,
      };

      listaCampos.push(campoNovo);

      this.getSortedList(campoBase.values).forEach(valorTemp => {
        this.copyValue(valorTemp, campoNovo.values);
      });
    },
    copyValue(valorBase, listaValores) {
      let valorNovo = {
        active: valorBase.active,
        sequenceNumber: this.getNextSequenceNumber(listaValores),
        value: valorBase.value,
        hasAdditionalField: valorBase.hasAdditionalField,
        additionalField: [],
      };
      
      listaValores.push(valorNovo);

      this.getSortedList(valorBase.additionalField).forEach(campoAddTemp => {
        this.copyField(campoAddTemp, valorNovo.additionalField);
      });
    },
    getNextSequenceNumber(items) {
      let sequence = 0;
      for (let item of items) {
        if (item.active == true) {
          if (item.sequenceNumber > sequence) {
            sequence = item.sequenceNumber;
          }
        }
      }
      return sequence + 1;
    },
  }
}

